import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

import { RecommendOptionValueModel } from '../utils/types';

export interface OthersSizeOptionProps {
  name: RecommendOptionValueModel['name'];
  heightRange: RecommendOptionValueModel['heightRange'];
  weightRange: RecommendOptionValueModel['weightRange'];
}

export function OthersSizeOption({ name, heightRange, weightRange }: OthersSizeOptionProps) {
  return (
    <Wrapper>
      <Label className={Typography.BODY_13_MEDIUM}>{name}</Label>
      <SizeRange className={Typography.BODY_13_REGULAR}>
        {heightRange && (
          <span>
            {heightRange.min}~{heightRange.max}cm
          </span>
        )}
        {weightRange && (
          <span>
            {weightRange.min}~{weightRange.max}kg
          </span>
        )}
      </SizeRange>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;

  &:last-of-type {
    padding: 8px 16px 16px;
  }
`;

const Label = styled.span`
  display: inline-block;
  margin-right: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  flex: 1 0 50px;
  color: ${vars.v3Color.gray700};
`;

const SizeRange = styled.div`
  text-align: right;
  color: ${vars.v3Color.gray700};

  span::after {
    display: inline-block;
    content: '';
    width: 2px;
    height: 2px;
    background: ${vars.v3Color.gray200};
    vertical-align: middle;
    border-radius: 50%;
    margin: 0 4px;
  }

  span:last-of-type::after {
    display: none;
  }
`;
